import { fastballGatewayDefaults } from './defaults';
import PlayerStoryModel from '../models/PlayerStoryModel';

export default {
    ...fastballGatewayDefaults,
    model: PlayerStoryModel,
    expires: false,
    pathTemplate: 'graphql/?query={query}&variables={variables}'
};
